/* Saved-pin deep links from Zone Settings. Keep URLs keyed by zone AND address. */
function getZonePinTarget() {
  var params = new URL(window.location.href).searchParams;
  if (params.get('type') === 'monthly') return null;
  var facilityId = params.get('focusFacilityId');
  var zoneId = params.get('focusZoneId');
  var address = params.get('focusPinAddress');
  return facilityId && zoneId && address ? { facilityId: facilityId, zoneId: zoneId, address: address } : null;
}

function isTargetZonePin(target, zoneId, address) {
  return !!target && target.zoneId === zoneId && target.address === address;
}

function showZonePinStatus(message, map) {
  var sidebar = $('#zone-pin-status');
  if (!sidebar.length) {
    sidebar = $('<p id="zone-pin-status" class="zone-pin-status" role="status"></p>');
    $('.search-results-list').before(sidebar);
  }
  sidebar.text(message);
  if (map) {
    if (!map.chirpPinStatus) {
      map.chirpPinStatus = document.createElement('p');
      map.chirpPinStatus.className = 'zone-pin-status';
      map.chirpPinStatus.setAttribute('role', 'status');
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(map.chirpPinStatus);
    }
    map.chirpPinStatus.textContent = message;
  }
}

async function initializeZonePinNavigation(target) {
  $('.site-content-overlay').addClass('site-content-overlay-active');
  $('.site-content-overlay-text').text('Finding saved map pin...');
  $('.search-results-list').empty();
  try {
    var response = await $.ajax({
      type: 'post', url: '/wp-admin/admin-ajax.php', dataType: 'json', timeout: 30000,
      data: { action: 'chirp_zone_pin_navigation', facilityId: target.facilityId, zoneId: target.zoneId, pinAddress: target.address }
    });
    if (!response.success) throw new Error(response.data.message);
    var data = response.data;
    var location = await geocodeZonePin(data.address);
    if (!location) throw new Error('The saved pin address could not be located. Please check its address in Zone Settings.');
    ['startDate', 'startTime', 'endDate', 'endTime'].forEach(function (key) {
      $('#' + key.replace(/[A-Z]/g, function (letter) { return '-' + letter.toLowerCase(); })).val(data[key]);
    });
    $('#address').val(data.address).attr({ 'data-latitude': location.lat(), 'data-longitude': location.lng(), 'data-offset': data.offset });
    $('#timezone').val(data.timezone);
    $('.search-toolbar-button-address').text(data.address);
    $('input[name="parking-type"][value="hourly"]').prop('checked', true);
    $('.search-results-list').html(data.template);
    UpdateMobileMapTime(data.startDateTime, data.endDateTime, data.timezone);
    searchResultsList();
    sortSearchResults();
    searchMap(location.lat(), location.lng(), 'map');
  } catch (error) {
    // The sidebar must work even if Google Maps itself cannot initialize.
    var message = error instanceof Error ? error.message : 'Unable to load this map pin. Please try again.';
    showZonePinStatus(message);
    try {
      searchMap(39.5, -98.35, 'map');
      var map = document.getElementById('map').chirpActiveMap;
      map.setZoom(4);
      showZonePinStatus(message, map);
    } catch (mapError) {
      // The error is already visible outside the map.
    }
  } finally {
    // Clear loading before invoking helpers that also depend on Google Maps.
    $('.site-content-overlay').removeClass('site-content-overlay-active');
    $('.site-content-overlay-text').empty();
    updateSearchForm();
    try {
      autocomplete();
    } catch (mapsError) {
      // Address search remains unavailable until the Maps configuration is fixed.
    }
  }
}
